<app-generic-input slug='subject_selector' [input]='true' inputAlign='right' (typing)='filter($event)' [disabled]='disabled'>
    <app-filters-placeholder-search class='placeholder'>
        <span *ngIf='!data.filters.subject'>נושא</span>
        <span *ngIf='data.filters.subject'>{{ data.filters.subject }}</span>
        <span *ngIf='data.filters.subject' class='clear' (click)='data.filters.subject = null; $event.stopPropagation()'>&times;</span>
    </app-filters-placeholder-search>
    <app-filters-dropdown-list-selector slug='subject_selector' class='popup' [data]='filtered' (selected)='select($event)' textAlign='right'>
    </app-filters-dropdown-list-selector>
</app-generic-input>